module.exports = __webpack_public_path__ + "static/Bosk.ttf-f3d09b9e68a3f9e1e37a4cae5a779238.woff";